/*
 * MAIN STYLES ENTRY FILE
 */

// Third Party
//THIS IS NOW LOADED ON THE TEMPLATE SEPARATELY AND ASYNCRONOUSLY
//require('./_kendo.custom.scss'); // enable/disable individual kendo component styles here
// ToDo: leftover replace with npm call
require('./ThirdParty/_fancybox.scss');
require('./ThirdParty/_slick.scss');
require('./ThirdParty/_slick-theme.scss');
require('./ThirdParty/splide-core.min.scss');
require('./_reset.scss');

// Main Styles 
require('./_animations.scss');
require('./_global.scss');
require('./_navigation.scss');
require('./_home.scss');
require('./_responsive.scss');
require('./_print.scss');

// Overrides + Fixes 
require('./_sf-editor-overrides.scss');
require('./_ie-edge-hacks.scss');